import { NavigationEffects } from './navigation.effects';
import { SessionEffects } from './session.effects';
import { UserEffects } from './user.effects';

export const AppEffects = [
  SessionEffects,
  UserEffects,
  NavigationEffects
];
